/*
 * @Author: your name
 * @Date: 2020-08-18 18:01:22
 * @LastEditTime: 2020-09-21 15:56:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ksh-doctor/src/util/tim.js
 */
import Vue from 'vue'
import TIM from 'tim-js-sdk'
import COS from 'cos-js-sdk-v5'
import imManager from './im-manager'

const SDKAppIdData = {
  'localhost':1400388764,
  'kshdoctor-dev.yaomaitong.net':1400388764,
  'kshdoctor.yaomaitong.net':1400388764,
  'kshdoctor.yaomaitong-pre.cn':1400404508,
  'kshdoctor.yaomaitong.cn':1400404508
}

const tim = TIM.create({
    SDKAppID: SDKAppIdData[window.location.hostname] || SDKAppIdData['localhost'], // 你的SDKAppID
    // 禁用统计上报 - 这是解决 events.im.qcloud.com 错误的关键
    disableStatistics: true
})
tim.setLogLevel(4) // release级别， SDK输出关键信息，生产环境时建议使用
tim.registerPlugin({ 'cos-js-sdk': COS })
window.tim = tim
window.TIM = TIM
Vue.prototype.$tim = tim
Vue.prototype.TIM = TIM

// IM 管理器将在 App.vue 中初始化，确保 Vue 和 store 已准备好

// 导出 IM 管理器实例
export { tim, TIM, imManager}
